import { Input as AntdInput, Form, Typography } from "antd";
import React, { useState } from "react";
import { config } from "../../config";
import LabelAndValue from "../../form/LabelAndValue";
import useInstantFocus from "../hooks/useInstantFocus";

function HInput(props) {
  const [hasError, setHasError] = useState(false);
  const { Text } = Typography;
  const {
    autoFocus,
    type = "",
    formItemName,
    formItemLabel,
    required,
    errorMessage,
    validator,
    size = "m",
    variant = "default",
    formItemRules = required
      ? [
          {
            required: true,
            validator: validator
              ? validator
              : (_, value) => {
                  if (!value) {
                    setHasError(true);
                    const label = formItemLabel || placeholder || "This field";
                    return Promise.reject(new Error(errorMessage ?? `${label} is required`));
                  } else {
                    setHasError(false);
                    return Promise.resolve();
                  }
                },
          },
        ]
      : [],
    formClassName = "",
    customClasses = "",
    value,
    name = "default",
    prefix = null,
    inputHelper,
    placeholder,
    tabIndex = -1,
    floatingLabel = true,
  } = props;

  const inputConfiguration = config.input.variant[variant] ?? {};
  const inputConfigurationBySize = config.input.size[size] ?? {};
  const inputHelperConfigurationBySize = config.text.size[inputHelper?.size];
  const inputHelperConfigurationByType = config.text.type[inputHelper?.type];

  const inputRef = useInstantFocus(autoFocus);

  const { customClasses: _customClasses, ...restProps } = props;
  const labelText = placeholder || formItemLabel || "";
  const isBorderless = variant === "borderless";
  const showFloatingLabel = floatingLabel && !!labelText && variant === "underlined";

  return (
    <LabelAndValue label={!showFloatingLabel && formItemLabel ? formItemLabel : undefined} hasError={hasError}>
      <Form.Item rules={formItemRules} name={formItemName} className={`mb-0 ${formClassName}`}>
        <div className={isBorderless ? "" : "hs-input-floating-label-wrapper"}>
          {showFloatingLabel && (
            <LabelAndValue floating={true} label={labelText} hasError={hasError} labelClass="hs-input-floating-label">
              <></>
            </LabelAndValue>
          )}
          <AntdInput
            {...restProps}
            name={name}
            key={name}
            value={value}
            ref={inputRef}
            placeholder={showFloatingLabel ? " " : placeholder}
            autoComplete="off"
            tabIndex={tabIndex}
            data-cy={props["data-cy"]}
            className={`py-0 ${customClasses} ${inputConfigurationBySize?.customClasses ?? ""} ${inputConfiguration?.customClasses} ${
              hasError ? "hs-input-has-error" : ""
            } ${showFloatingLabel ? "hs-input-with-floating-label" : ""}`}
            prefix={prefix}
          />
        </div>
      </Form.Item>
      {inputHelper && (
        <Text
          className={`${inputHelperConfigurationBySize?.customClasses ?? ""} ${inputHelperConfigurationByType?.customClasses ?? ""}`}
        >
          {inputHelper?.text}
        </Text>
      )}
    </LabelAndValue>
  );
}

export default React.memo(HInput);
